/**
 * kult-home-gifts.js — Budget-Regler der Startseiten-Geschenke-Section (sections/kult-home-gifts.liquid, Block „budget“).
 * Zeigt den Wunschpreis neben dem Regler an und schreibt ihn als ?budget=<Euro> in den Link „Box erstellen“; der
 * Box-Konfigurator (assets/kult-gift-builder.js, autofill) stellt die Kult-Box dann passend zusammen. Ohne JS führt der
 * Link mit dem Standardwert zur Geschenke-Seite. Theme-Editor: shopify:section:load initialisiert neu.
 */
(function () {
  'use strict';
  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    Array.prototype.forEach.call(scope.querySelectorAll('[data-budget]'), function (wrap) {
      if (wrap.hasAttribute('data-budget-ready')) return;
      var range = wrap.querySelector('[data-budget-range]');
      var out = wrap.querySelector('[data-budget-value]');
      var link = wrap.querySelector('[data-budget-link]');
      if (!range || !link) return;
      wrap.setAttribute('data-budget-ready', '');
      var base = link.getAttribute('data-budget-base') || link.getAttribute('href') || '';
      var hash = link.getAttribute('data-budget-hash') || '';
      var update = function () {
        var euro = parseInt(range.value, 10) || 0;
        if (out) out.textContent = euro + '\u00a0€';
        var sep = base.indexOf('?') === -1 ? '?' : '&';
        link.setAttribute('href', base + sep + 'budget=' + euro + hash);
        range.setAttribute('aria-valuetext', euro + ' Euro');
      };
      range.addEventListener('input', update, { passive: true });
      range.addEventListener('change', update, { passive: true });
      update();
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
